var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Typography } from '@material-ui/core';
import styled from 'react-emotion';
export var Wrapper = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-rows: auto 1fr;\n  width: 100%;\n  min-height: 400px;\n"], ["\n  display: grid;\n  grid-template-rows: auto 1fr;\n  width: 100%;\n  min-height: 400px;\n"])));
export var Title = styled(Typography)({
    '&&': {
        fontWeight: 400,
        fontSize: 15
    }
});
var templateObject_1;
//# sourceMappingURL=CampaignOversightLogs.Styles.js.map